module.exports = __webpack_public_path__ + "static/media/elbowStrength2.e7f85155.png";